/*
 * Module for the plan breakdown tab of Benefit Summary screens
*/

rs.module("framework/benefitsummary/planbreakdown",

    [],

    function () {

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrls) {

            // on plan change, reload plan breakdown
            $.js(jsSelectors.planSelect).change(function () {

                $.js(jsSelectors.loadingSpinner).show();

                $.get(
                    backendUrls.getPlanBreakdown,
                    {
                        planKey: $(this).val()

                    }).done(function (result) {

                        $.js(jsSelectors.breakdownDetail).html(result);
                        $.js(jsSelectors.loadingSpinner).hide();
                    });
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);